module.exports = __webpack_public_path__ + "static/media/github_logo.8a35a6eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/github_logo.png
// module id = 61
// module chunks = 0